// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 100px);
  padding-bottom: 100px;
  margin-bottom: 100px;
  width: 100%;
  box-sizing: border-box; 
}

*,
*::before,
*::after {
    box-sizing: border-box;
}
  
.video-detail {
  padding: 20px;
}

.video-detail iframe {
  max-width: 100%;
  border-radius: 8px;
}

.video-detail h2 {
  margin-bottom: 10px;
}

.video-detail p {
  font-size: 16px;
  color: #555;
}

.video-detail a {
  display: inline-block;
  margin-top: 20px;
  text-decoration: none;
  color: #047da2;
  font-weight: bold;
}
  
.capacitaciones-title {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 55px;
  text-align: center;
  color: #047da2;
  margin-top: 20px;
  margin-bottom: 30px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); 
  gap: 20px;
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
  max-width: 1200px;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.pagination button {
  background: #bdbdbd;
  border: none;
  color: #ffffff;
  padding: 8px 16px;
  margin: 0 5px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14.5px;
  line-height: 18px;
  cursor: pointer;
  border-radius: 8px;
}

.pagination button.active {
  background: #07afe3;
}

@media (max-width: 768px) {
  .video-grid {
    padding: 20px;
    max-width: 768px;
    width: 100%; 
    box-sizing: border-box;
  }

  .capacitaciones-title{
    font-size: 35px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Trainings/TrainingPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".app-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: calc(100vh - 100px);\n  padding-bottom: 100px;\n  margin-bottom: 100px;\n  width: 100%;\n  box-sizing: border-box; \n}\n\n*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n  \n.video-detail {\n  padding: 20px;\n}\n\n.video-detail iframe {\n  max-width: 100%;\n  border-radius: 8px;\n}\n\n.video-detail h2 {\n  margin-bottom: 10px;\n}\n\n.video-detail p {\n  font-size: 16px;\n  color: #555;\n}\n\n.video-detail a {\n  display: inline-block;\n  margin-top: 20px;\n  text-decoration: none;\n  color: #047da2;\n  font-weight: bold;\n}\n  \n.capacitaciones-title {\n  font-family: 'Roboto', sans-serif;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 55px;\n  text-align: center;\n  color: #047da2;\n  margin-top: 20px;\n  margin-bottom: 30px;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0 20px;\n}\n\n.video-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); \n  gap: 20px;\n  padding: 0 20px;\n  width: 100%;\n  box-sizing: border-box;\n  max-width: 1200px;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: 40px;\n}\n\n.pagination button {\n  background: #bdbdbd;\n  border: none;\n  color: #ffffff;\n  padding: 8px 16px;\n  margin: 0 5px;\n  font-family: 'Roboto', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14.5px;\n  line-height: 18px;\n  cursor: pointer;\n  border-radius: 8px;\n}\n\n.pagination button.active {\n  background: #07afe3;\n}\n\n@media (max-width: 768px) {\n  .video-grid {\n    padding: 20px;\n    max-width: 768px;\n    width: 100%; \n    box-sizing: border-box;\n  }\n\n  .capacitaciones-title{\n    font-size: 35px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
